import { Operator } from "./operator";

export class UserAccount {
  operator: Operator;
  superUser: boolean = false;
  eulaAccepted: boolean = false;
}
